export default {
  page_header: {
    title: "За",
    description: "Преглед на порталот, неговите функции и тековна верзија.",
  },

  // Tabs
  tabs: {
    overview_tab: {
      name: "Преглед",
      title: "Портал на {laboratoryName}",
      subtitle: "Онлајн пристап до резултати, примероци и плаќања.",
      description:
        "{laboratoryName} им дава на пациентите и лабораторискиот персонал едно безбедно место за пристап до резултати, управување со примероци и проверка на плаќања — од кој било уред, на три јазика.",

      version_info: {
        header: "Информации за верзија:",
        frontend: "Верзија на Frontend: 0.3.3",
        backend: "Верзија на Backend: 0.0.1",
      },

      features: {
        header: "Функции и можности:",

        sample_management: {
          title: "Управување со примероци",
          subtitle: "Следење на примерокот од земањето до крајниот резултат.",
        },
        real_time_results: {
          title: "Резултати во реално време",
          subtitle: "Синхронизација во реално време со лабораториските инструменти.",
        },
        multilingual_support: {
          title: "Мултијазична поддршка",
          subtitle: "Лесно префрлување помеѓу англиски, бугарски и македонски.",
        },
        secure_authentication: {
          title: "Безбедна автентикација",
          subtitle: "Безбедна најава преку Keycloak — вашите податоци се заштитени.",
        },
        responsive_design: {
          title: "Респонзивен дизајн",
          subtitle: "Полна поддршка за компјутер, таблет и телефон.",
        },
        accessibility: {
          title: "Достапност",
          subtitle: "Соодветство со WCAG 2.1 AA стандарди за достапност.",
        },
        high_performance: {
          title: "Високи перформанси",
          subtitle: "Брзо вчитување дури и со голем број резултати.",
        },
      },

      targetUsers: {
        header: "Корисници на порталот:",

        otp_patients: {
          title: "ОТП Пациенти",
          subtitle: "Онлајн пристап до резултати и финансов биланс.",
        },
        lab_technicians: {
          title: "Лабораториски техничари",
          subtitle: "Обработка и проверка на дојдовни примероци.",
        },
        pathologists: {
          title: "Патолози и специјалисти",
          subtitle: "Преглед и валидација на резултати од различни оддели.",
        },
        lab_administrators: {
          title: "Администратори на лаборатории",
          subtitle: "Надзор врз оптоварувањето, корисниците и дневните операции.",
        },
      },
    },

    services_tab: {
      name: "Сервиси",
      title: "Сервиси на LIS Portal",
      subtitle: "Самоуслужен веб портал за лабораториски резултати и плаќања",

      refresh_button: "Освежување на сервиси",
      refreshTooltip: "Освежување на сервиси",
      openApp: "Отвори апликација",
      openApiDocs: "OpenAPI документација",
      healthCheck: "Проверка на здравје",
    },

    actions_tab: {
      name: "Акции",
      title: "Акции на порталот",
      subtitle: "Управување со кеш и конфигурации на системот",

      cache_card: {
        title: "Освежување на кеш",
        content:
          "Освежете го кешот од страна на серверот за да наметнете освежување на сите податоци од базата на податоци.",
        action: "Освежување на кеш",
      },
    },

    copyright_tab: {
      name: "Авторски права",
      title: "Авторски права",
      subtitle: "Интелектуална сопственост и лиценци",

      description_start: "Сите интелектуални сопствености на оваа апликација припаѓаат на ",
      company_name: "SKYWARE Group",
      description_end:
        ". Правата на компонентите и библиотеките користени во оваа апликација им припаѓаат на нивните автори и се соодветно лиценцирани како што е опишано подолу.",
    },

    credits_tab: {
      name: "Заслуги",
      title: "Заслуги",
      subtitle: "Изградено со технологии со отворен код",

      application_title: "Lab Portal",
      authors_of_application: "Автори на оваа апликација",
      licence: "лиценца",
      et_al: "и др",
    },
  },
};
